import Vue, { ref } from 'vue'

export class ServicioDeListado {
	#desconectar;
	#refColección;

	/**
	 * 
	 * @param {*} refCol - Referencia de colección de Firebase
	 */
	constructor(refCol) {
		this.#desconectar = null
		this.listado = ref([])
		this.listando = ref(false)
		this.listar(refCol)
	}

	/**
	 * 
	 * @param {*} [refCol] - Referencia de colección de Firebase
	 */
	listar(refCol) {
		if (this.#desconectar) {
			this.#desconectar()
		}

		if (refCol) {
			this.#refColección = refCol
		}

		this.listado.value = []
		this.listando.value = true
		this.#desconectar = this.#refColección.onSnapshot( snapshot => {
			this.#manejarCambiosFirebase(snapshot, { agregarAlInicio: true })
			this.listando.value = false
		})
	}

	#manejarCambiosFirebase(snapshot, opciones) {
		snapshot.docChanges().forEach( change => {
			let f = () => true
			if (opciones && opciones.filtro && typeof opciones.filtro === 'function') {
				f = opciones.filtro
			}

			let D = Object.assign(change.doc.data(), {identificador: change.doc.id})
			if (change.type === "added") {
				let alInicio = opciones && opciones.agregarAlInicio
				if (f(D)) {
					if (alInicio) {
						this.listado.value.splice(0, 0, D)
					} else {
						this.listado.value.push(D)
					}
				}
			}
			if (change.type === "modified") {
				for (let i in this.listado.value) {
					if (this.listado.value[i].identificador === change.doc.id && f(this.listado.value[i])) {
						Vue.set(this.listado.value, i, D) // PENDIENTE: Revisar si es necesario el set
						break
					}
				}
			}
			if (change.type === "removed") {
				for (let i in this.listado.value) {
					if (this.listado.value[i].identificador === change.doc.id && f(this.listado.value[i])) {
						Vue.delete(this.listado.value, i) // PENDIENTE: Revisar si es necesario el delete
						break
					}
				}
			}
		})
	}

	desconectar() {
		this.#desconectar()
		this.#desconectar = null
		this.#refColección = null
		this.listado.value = []
	}
}
